import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Button,
  Link,
  SvgIcon,
  Typography
} from '@mui/material';

import { languageSelection } from '../../shared/translationConfig/helper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function WarningIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      data-testid="warning-icon"
      viewBox="0 0 80 71"
    >
      <path
        d={`
          M8.33905 70.8646H71.0891C77.5057 70.8646 81.5057 63.9062 78.2974 58.3646L46.9224 4.15625
          C43.714 -1.38542 35.714 -1.38542 32.5057 4.15625L1.13071 58.3646C-2.07762 63.9062 1.92238 70.8646 8.33905 70.8646Z
          M39.714 41.6979C37.4224 41.6979 35.5474 39.8229 35.5474 37.5312V29.1979C35.5474 26.9062 37.4224 25.0312 39.714 25.0312
          C42.0057 25.0312 43.8807 26.9062 43.8807 29.1979V37.5312C43.8807 39.8229 42.0057 41.6979 39.714 41.6979Z
          M43.8807 58.3646H35.5474V50.0312H43.8807V58.3646Z
        `}
        fill="#404945"
      />
    </SvgIcon>
  );
}

function NotFoundPage() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const sessionLang = languageSelection();
    if (sessionLang !== null) {
      i18n.changeLanguage(sessionLang);
    }
  }, [i18n]);

  return (
    <Box
      className="flex flex-col items-center justify-center"
      sx={{
        marginTop: {
          md: '10rem',
          xs: '4rem'
        }
      }}
    >
      <Box
        sx={{
          paddingX: {
            xl: '17rem',
            lg: '10rem',
            sm: '5rem',
            xs: '0'
          },
          textAlign: 'center'
        }}
      >
        <WarningIcon sx={{ fontSize: 80 }} />

        <Typography
          align="center"
          className="text-bold my-lg"
          sx={{
            textTransform: 'capitalize',
            my: 'var(--padding-lg)',
            color: 'var(--sprout-text-primary, #101C16)',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily:
              'var(--font-family-helvetica-now, "Helvetica Now For Cargill")',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: {
              xs: '18px',
              md: '20px'
            },
            lineHeight: {
              xs: '24px',
              md: '26px'
            }
          }}
        >
          404 {t('notFound.errText')}
        </Typography>

        {/* Description */}
        <Typography
          className="mb-2xl text-base"
          sx={{
            font: 'var(--sprout-font-body1)',
            color: 'var(--sprout-text-primary, #101C16)',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily:
              'var(--font-family-helvetica-now, "Helvetica Now For Cargill")',
            fontStyle: 'normal'
          }}
        >
          {t('notFound.errDesPrefix')}
          <Link component={RouterLink} to="/help">
            {t('notFound.errLinkText')}
          </Link>
          {t('notFound.errDesSuffix')}
        </Typography>

        <Box sx={{ mt: 'var(--spacing-2xl)' }}>
          <Button
            variant="contained"
            aria-label="Back to dashboard"
            data-testid="anchor"
            component={RouterLink}
            to="/secure/dashboard"
            sx={{
              width: {
                xs: '100%',
                sm: 'auto'
              },
              height: '40px'
            }}
          >
            {t('notFound.homBtn')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default NotFoundPage;